module.exports = __webpack_public_path__ + "img/Pg_heading_bg.3013f9db.png";